<svelte:options customElement="rf-collections" />

<script>
	import { collections } from '@store/collections.svelte.ts';
	import ReframeCollectionCard from '@core/rf-collection-card/rf-collection-card.svelte';

	let isVisible = $state(false);
</script>

<button class="rf-collections-button" onclick={(isVisible = !isVisible)}>{isVisible ? 'Hide' : 'Show'} Refame's collections metas</button>

<div class={['rf-collections', { visible: isVisible }]}>
	{#each collections as collection}
		<ReframeCollectionCard item={collection} />
	{/each}
</div>

<style lang="scss" global>
	.rf-collections {
		background-color: var(--rf-primary-font-color, #17181b);
		padding: var(--rf-spacing-s, 8px);
		border-radius: var(--rf-spacing-xs, 4px);
		display: none;

		&.visible {
			display: block;
		}
	}

	.rf-collections-button {
		width: 100%;
		background-color: var(--rf-primary-font-color, #17181b);
		padding: var(--rf-spacing-s, 8px);
		border-radius: var(--rf-spacing-xs, 4px);
		color: white;
		font-family: var(--rf-font-family);
		color: var(--rf-secondary-font-color, #fff);
		border: none;
		cursor: pointer;

		&:hover {
			opacity: 0.8;
		}
	}
</style>
